import { ReactNode, useEffect, useState, ReactElement } from "react";
import { useSelector } from "react-redux";

import { RootState } from "@/lib/redux/types";
import { FormConfig } from "@evergiving/common/dist/es2015/form";
import { PaymentFrequency } from "@evergiving/common/dist/es2015/pledge";
import { Nav } from "@/lib/components/Nav";
import { CountrySwitcher } from "@/lib/components/CountrySwitcher";
import { amountSelector } from "@/lib/misc/amountSelector";
import { useFormRouter } from "@/lib/hooks/useFormRouter";
import { LogoContainer } from "@/lib/components/LogoContainer";
import { PageContainer } from "@/lib/components/PageContainer";

export function PaymentPageContainer({
  formConfig,
  children,
}: {
  formConfig: FormConfig;
  children: ReactNode;
}): ReactElement {
  const amount = useSelector(amountSelector);
  const paymentFrequency: PaymentFrequency | undefined = useSelector(
    (state: RootState) => state.paymentFrequency
  );
  const formRouter = useFormRouter();
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    if ("payment" in formConfig) {
      const valid = amount.value > 0 && paymentFrequency !== undefined;
      if (valid) {
        setLoaded(true);
      } else if (
        !loaded &&
        (amount.value <= 0 || paymentFrequency === undefined)
      ) {
        formRouter.replaceWithPage("index");
      }
    } else {
      setLoaded(true);
    }
  }, [amount, paymentFrequency, formRouter, loaded]);

  return (
    <div id="container" className="paymentFormOtherMethod">
      <header className="small">
        <LogoContainer formConfig={formConfig} />
      </header>
      <CountrySwitcher otherLocales={formConfig.otherLocales} />
      <PageContainer formConfig={formConfig}>
        {loaded && (
          <main lang={formConfig.locale}>
            {"payment" in formConfig ? (
              <Nav
                paymentFieldConfig={formConfig.payment}
                locale={formConfig.locale}
              />
            ) : null}
            {children}
          </main>
        )}
      </PageContainer>
    </div>
  );
}
